import React from 'react'
import moment from 'moment'
import { RouteHandler, Link } from 'react-router'
import DocumentTitle from 'react-document-title'
import { prefixLink } from 'gatsby-helpers'
import access from 'safe-access'
import { config } from 'config'
import ReadNext from '../ReadNext'
import Footer from '../Footer'
import './style.css'
import '../../static/css/highlight.css'
import profilePic from '../../pages/photo.jpg'

class SitePost extends React.Component {
    render() {
        const {route} = this.props
        const post = route.page.data
        const home = (
        <div>
          <Link className='gohome' to={ prefixLink('/') }> Back to Home
          </Link>
        </div>
        )

        return (
            <div className="post">
              { home }
              <div className='blog-single'>
                <div className='text'>
                  <h2>{ post.title }</h2>
                  <div dangerouslySetInnerHTML={ {    __html: post.body} } />
                    <div className="meta">
                      <div className='date-published'>
                        <p className="date">Published { moment(post.date).format('D MMM YYYY') }</p>
                      </div>
                      <div className='author'>
                        <h4>Husam Machlovi</h4>
                        {/*<img src={prefixLink(profilePic)} width='75' height='75' />*/}
                        <p>
                          { config.siteDescr }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="read-next">
                  <ReadNext post={ post } {...this.props}/>
                </div>
                <Footer {...this.props} />
            </div>
            );
    }
}

SitePost.propTypes = {
    post: React.PropTypes.object.isRequired,
    pages: React.PropTypes.array,
}

export default SitePost



// WEBPACK FOOTER //
// ../components/SitePost/index.jsx